import { jsx as _jsx } from "react/jsx-runtime";
import Pill from '@ingka/pill';
export default ({ dataTestId, ...props }) => {
    return _jsx(Pill, { ...props, "data-testid": dataTestId });
};
//# sourceMappingURL=SkapaPill.js.map